import { ConfirmModal } from '@/components/patterns/ConfirmModal';
import { STRINGS } from '@/strings/strings';

/**
 * Confirm-redirect modal for the "Abo kündigen" flow on
 * `/account/subscription`. Now consumes the shared
 * `pwa/src/components/patterns/ConfirmModal.tsx` (Batch 9B Commit 1
 * extraction — promoted per the FB-5 ≥2-consumer rule once Batch 9B
 * Delete-Child-Confirm became the 2nd consumer).
 *
 * Copy locked at Batch 9A Gate-0 + reaffirmed at Gate-1 FB-3 — primary
 * CTA is "Kündigung fortsetzen" (NOT the mockup's "Weiter zu Stripe").
 * Body is the verbatim Sebastian-Gate-0 wording (subset of the mockup
 * version; drops the "Die Kündigung erfolgt über Stripe…" trailing
 * sentence).
 */
export interface CancelConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /**
   * Pre-formatted DD.MM.YYYY date — caller owns formatting (typically
   * the subscription's `currentPeriodEnd`).
   */
  endDate: string;
  /**
   * Fired when the user taps the primary CTA. The route handler
   * typically: closes the modal, then triggers a portal-session
   * redirect with `flow='subscription_cancel'`.
   */
  onConfirm: () => void;
}

export function CancelConfirmModal({
  open,
  onOpenChange,
  endDate,
  onConfirm,
}: CancelConfirmModalProps) {
  const copy = STRINGS.account.cancelModal;
  return (
    <ConfirmModal
      open={open}
      onOpenChange={onOpenChange}
      headline={copy.headline}
      body={copy.body.replace('{date}', endDate)}
      primaryCta={copy.primaryCta}
      secondaryCta={copy.secondaryCta}
      onConfirm={onConfirm}
      testId="cancel-confirm-modal"
    />
  );
}
